export default __webpack_public_path__ + "static/media/background.469c3b18.jpg";